define('display/layers/labelsLayerMixinFactory',[], function() {
    'use strict';
    function getFlagName(baseName) {
        return '_' + baseName + 'Added';
    }

    function getFlag(source, flagName) {
        return source[getFlagName(flagName)];
    }

    function addIfNecessary(source, map, baseLayerName) {
        if (source._attached) {
            return;
        }
        if (getFlag(source, baseLayerName) && (getFlag(source, 'traffic') || getFlag(source, 'trafficFlow'))) {
            map.addLayer(source);
            source._attached = true;
        }
    }

    function removeIfNecessary(source, map, baseLayerName) {
        if (!source._attached) {
            return;
        }
        if (!getFlag(source, baseLayerName) || !getFlag(source, 'traffic') && !getFlag(source, 'trafficFlow')) {
            map.removeLayer(source);
            source._attached = false;
        }
    }

    return function(baseLayerName) {
        return {
            registerEventHandlers: function(map) {
                var that = this;

                map.on('layeradd', function(event) {
                    var layerName = event.layer.name;
                    if (!layerName) {
                        return;
                    }

                    that[getFlagName(layerName)] = true;
                    addIfNecessary(that, map, baseLayerName);
                });
                map.on('layerremove', function(event) {
                    var layerName = event.layer.name;
                    if (!layerName) {
                        return;
                    }

                    that[getFlagName(layerName)] = false;
                    removeIfNecessary(that, map, baseLayerName);
                });
            }
        }
    }
});

